import React from 'react';
import { styled } from '@linaria/react';

import Demo, { Props as BaseDemoProps } from '@/components/Demo';

import PerspectiveToggle from './PerspectiveToggle';

interface Props extends BaseDemoProps {
  defaultPerspectiveEnabled?: boolean;
  children: (controlValues: Record<string, any>) => React.ReactNode;
  hidePerspectiveControl?: boolean;
}

function GridDemo({
  defaultPerspectiveEnabled = true,
  children,
  hidePerspectiveControl,
  ...delegated
}: Props) {
  const id = React.useId().replace(/:/g, '');

  const [isPerspectiveEnabled, setIsPerspectiveEnabled] =
    React.useState(defaultPerspectiveEnabled);

  return (
    <Demo
      {...delegated}
      id={`grid-demo-${id}`}
      outputWrapper={null}
      controlPosition="top"
    >
      {(controlValues) => (
        <Wrapper>
          {children({ ...controlValues, isPerspectiveEnabled })}
          {!hidePerspectiveControl && (
            <GridPerspectiveToggle
              id={id}
              isPerspectiveEnabled={isPerspectiveEnabled}
              setIsPerspectiveEnabled={setIsPerspectiveEnabled}
            />
          )}
        </Wrapper>
      )}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GridPerspectiveToggle = styled(PerspectiveToggle)`
  align-self: center;
`;

export default GridDemo;
